import React, { MouseEvent, MouseEventHandler } from 'react';
import NextLink from 'next/link';
import { Button, forwardRef, Text } from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';
import { IoPricetagOutline } from './Icons';

type Tag = {
  id: number;
  name: string | null;
};

type TagButtonProps = {
  tag: Tag;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  href?: string;
};

const TagButton = forwardRef<TagButtonProps, 'a'>(
  ({ tag, onClick, href }, ref) => {
    function onClickTagButtonLink(e: MouseEvent<HTMLButtonElement>) {
      sendAnalyticsEvent('slide', 'index', 'frequently_used_tag');
      onClick?.(e);
    }

    return (
      <Button
        display="inline-block"
        color="inherit"
        _hover={{
          textDecoration: 'none',
        }}
        href={href}
        variant="link"
        as="a"
        onClick={onClickTagButtonLink}
      >
        <Text
          px={2}
          py={{ base: 0.5, md: 1 }}
          fontSize="sm"
          fontWeight="bold"
          bg="white"
          color="brand.500"
          border="1px"
          borderRadius="full"
        >
          #{tag.name}
        </Text>
      </Button>
    );
  },
);

export default function TagButtonLink({ tag }: { tag: Tag }) {
  return (
    <NextLink href={`/tagsearch/${tag.id}`} passHref>
      <TagButton tag={tag} />
    </NextLink>
  );
}
